module.exports = __webpack_public_path__ + "images/9d5fe5a9cbbd1c221f963e3bd54c759f.jpg";